import { useMutation } from "@tanstack/react-query";
import isClient from "../isClient";

const host = isClient() ? "" : "http://localhost";
const emailSignUpPostRequest = (emailStr: string) =>
  fetch(`${host}/research/api/newsletter-signup`, {
    method: "POST",
    body: JSON.stringify({ email: emailStr }),
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  }).then((response) => {
    if (!response.ok) {
      throw new Error("Bad Request");
    }
    return response;
  });

const useEmailNewsletterSignup = () => {
  const emailSignUpMutation = useMutation({
    mutationFn: emailSignUpPostRequest,
  });
  return {
    emailSignUpMutation,
  };
};

export default useEmailNewsletterSignup;
